import { useDropdownContext } from '../../DropdownProvider';
import { useBodyScrollLock } from '../../../hooks/useBodyScrollLock';

export function useMobileNavBodyScrollLock() {
  const { state } = useDropdownContext();
  useBodyScrollLock(state.isShowingMobileNav);
}
